// extracted by mini-css-extract-plugin
export default {"wrap":"e865146b7620"};